export default __webpack_public_path__ + "static/media/prismaLogoDark.d4db5184.png";